import type { PlatformSummary } from '@pixel-archive/shared';

const logos: Record<string, string> = {
  alice32: 'matra_alice.png',
  amstradcpc: 'amstrad_cpc.svg',
  amstradcpc464: 'amstrad_cpc.svg',
  amstradcpc6128: 'amstrad_cpc.svg',
  atari2600: 'atari_2600.svg',
  atari520stf: 'atari_st.svg',
  atari800: 'atari_800.svg',
  atari800xl: 'atari_800.svg',
  atarilynx: 'atari_lynx_transparent.png',
  atarist: 'atari_st.svg',
  colecovision: 'coleco_vision.svg',
  commodore64: 'commodore_64_transparent.png',
  commodoreamiga: 'commodore_amiga.svg',
  commodorevic20: 'commodore_vic20.svg',
  dreamcast: 'sega_dreamcast.svg',
  dragon32: 'dragon32_transparent.png',
  famicom: 'nintendo_famicom.svg',
  gameandwatch: 'game_and_watch_official.webp',
  gamewatch: 'game_and_watch_official.webp',
  gw: 'game_and_watch_official.webp',
  nintendogamewatch: 'game_and_watch_official.webp',
  nintendogameandwatch: 'game_and_watch_official.webp',
  gameboy: 'nintendo_gameboy.png',
  gameboycolor: 'nintendo_gameboy_color.svg',
  gameboygameboycolor: 'nintendo_gameboy_color.svg',
  gameboyadvance: 'nintendo_gameboy_advance.svg',
  gamegear: 'sega_gamegear.svg',
  intellivision: 'intellivision.svg',
  matraalice: 'matra_alice.png',
  matraalice32: 'matra_alice.png',
  megadrivegenesis: 'sega_genesis.svg',
  megadrive: 'sega_genesis.svg',
  segamegadrive: 'sega_genesis.svg',
  megadrivejapon: 'megadrive_japan_transparent.png',
  microvision: 'microvision.png',
  msx: 'msx.svg',
  msx2: 'msx2.svg',
  neogeopocket: 'snk_neogeo_pocket.svg',
  nintendo3ds: 'nintendo_3ds.svg',
  nintendo64: 'nintendo_64.svg',
  nintendods: 'nintendo_ds.svg',
  nintendones: 'nintendo_nes.svg',
  nintendoswitch: 'nintendo_switch_transparent.png',
  odyssey2videopac: 'philips_videopac.png',
  oric: 'oric.png',
  oric1: 'oric.png',
  oricatmos: 'oric.png',
  philipsvg5000: 'philips_vg5000.svg',
  playstation: 'playstation.png',
  playstation2: 'playstation_ps2.svg',
  playstation3: 'playstation3.svg',
  playstation5: 'playstation5_flat.svg',
  psp: 'playstation_psp.svg',
  saturn: 'sega_saturn.svg',
  segamastersystem: 'sega_master_system.svg',
  seb: 'seb.svg',
  sebtelescore: 'seb.svg',
  superfamicom: 'super_famicom_transparent.png',
  supernintendo: 'nintendo_snes.svg',
  thomson: 'thomson.svg',
  thomsonmo5: 'thomson.svg',
  thomsonmo6: 'thomson.svg',
  thomsonto770: 'thomson.svg',
  vg5000: 'philips_vg5000.svg',
  videopac: 'philips_videopac.png',
  wii: 'nintendo_wii.svg',
  wonderswan: 'wonderswan_official.webp',
  wonderswancolor: 'bandai_wonderswan_color.svg',
  sinclairzx81: 'sinclair_zx81_transparent.png',
  zx81: 'sinclair_zx81_transparent.png',
  zxspectrum: 'sinclair_zxspectrum.svg',
  zxspectrum2: 'sinclair_zxspectrum.svg',
  zxspectrum48k: 'sinclair_zxspectrum.svg',
};

export const invertedPlatformLogos = new Set([
  'game_and_watch_official.webp',
  'intellivision.svg',
  'wonderswan_official.webp',
  'philips_vg5000.svg',
  'playstation3.svg',
  'thomson.svg',
]);

const identity = (value = '') =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('fr')
    .replace(/[^a-z0-9]/g, '');

export function platformLogoFile(platform: Pick<PlatformSummary, 'code' | 'name'>): string | null {
  const code = identity(platform.code);
  const name = identity(platform.name);
  const exact = logos[code] ?? logos[name];
  if (exact) return exact;
  if (name.startsWith('msx2') || code.startsWith('msx2')) return logos.msx2;
  if (name.startsWith('msx') || code.startsWith('msx')) return logos.msx;
  if (name.startsWith('amstradcpc')) return logos.amstradcpc;
  if (name.startsWith('atari800')) return logos.atari800;
  if (name.startsWith('atarist') || name.startsWith('atari520st')) return logos.atarist;
  if (name.startsWith('thomson') || code.startsWith('thomson')) return logos.thomson;
  if (name.startsWith('oric') || code.startsWith('oric')) return logos.oric;
  if (name.startsWith('matraalice') || code.startsWith('matraalice')) return logos.matraalice;
  if (name.startsWith('sebtelescore') || code.startsWith('sebtelescore')) return logos.sebtelescore;
  if (name.includes('videopac') || code.includes('videopac') || name.startsWith('odyssey2'))
    return logos.videopac;
  return null;
}
